import { render, staticRenderFns } from "./DistributionManager.vue?vue&type=template&id=5f2d01fe&scoped=true&"
import script from "./DistributionManager.vue?vue&type=script&lang=js&"
export * from "./DistributionManager.vue?vue&type=script&lang=js&"
import style0 from "./DistributionManager.vue?vue&type=style&index=0&id=5f2d01fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d01fe",
  null
  
)

export default component.exports